"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CommentsSection = void 0;
var _mobxReactLite = require("mobx-react-lite");
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _api = require("../../services/api");
var _theme = require("../../theme");
var _reactNativeUiLib = require("react-native-ui-lib");
var _DynamicForm = _interopRequireWildcard(require("../DynamicForm"));
var _DynamicTable = _interopRequireDefault(require("../DynamicTable"));
var _reactRouterDom = require("react-router-dom");
var _state = require("../state");
var _native = require("@react-navigation/native");
var _LayoutScreen = _interopRequireDefault(require("./LayoutScreen"));
var _reactNativeWebview = require("react-native-webview");
var _zustand = require("zustand");
var _reactNativeEvaIcons = require("react-native-eva-icons");
var _pluralize = _interopRequireDefault(require("pluralize"));
var _antd = require("antd");
var _ModalStore = require("../state/ModalStore");
var _FormStore = require("../state/FormStore");
var _PermissionStore = require("../state/PermissionStore");
var _CustomModalProvider = require("../CustomModalProvider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var CommentsSection = exports.CommentsSection = function CommentsSection() {
  var _React$useState = _react["default"].useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    comments = _React$useState2[0],
    setComments = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    newComment = _React$useState4[0],
    setNewComment = _React$useState4[1];
  var handleCommentSubmit = function handleCommentSubmit() {
    if (newComment) {
      setComments([].concat(_toConsumableArray(comments), [{
        user: 'Current User',
        message: newComment,
        id: comments.length + 1
      }]));
      setNewComment('');
    }
  };
  var renderCommentItem = function renderCommentItem(_ref) {
    var item = _ref.item;
    return /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
      row: true,
      top: true
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Avatar, {
      size: 30,
      label: item.user.charAt(0)
      // backgroundColor={Colors.violet30}
      ,
      containerStyle: {
        marginRight: 12
      }
      // labelColor={Colors.white}
      ,
      useAutoColors: true
    }), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Card, {
      "padding-20": true,
      flex: true
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
      row: true,
      left: true,
      centerV: true
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
      "marginR-5": true
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Text, {
      style: {
        fontWeight: 'bold',
        color: '#343434'
      }
    }, item.user)), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Text, {
      style: {
        color: '#34343466',
        fontSize: 12
      }
    }, "Commented")), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, null, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Text, null, item.message))))
    // <ListItem
    //   activeBackgroundColor={Colors.dark60}
    //   activeOpacity={0.3}
    //   containerStyle={{ paddingVertical: 12 }}
    //   onPress={() => {}}
    // >
    //   <Avatar
    //     label={item.user.charAt(0)}
    //     backgroundColor={Colors.violet30}
    //     containerStyle={{ marginRight: 12 }}
    //     labelStyle={{ fontWeight: 'bold' }}
    //   />
    //   <ListItem.Content>
    //     <View style={{ flexDirection: 'row', alignItems: 'center' }}>
    //       <Text style={{ flex: 1 }}>{item.user}</Text>
    //       <Text style={{ color: Colors.dark40 }}></Text>
    //     </View>
    //     <Text style={{ ...Typography.text70, marginTop: 4 }}>{item.message}</Text>
    //   </ListItem.Content>
    // </ListItem>
    ;
  };
  var formatDate = function formatDate(date) {
    // Format the date as per your requirement
    return "".concat(date.getMonth() + 1, "/").concat(date.getDate(), "/").concat(date.getFullYear());
  };
  return /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.FlatList, {
    data: comments,
    renderItem: renderCommentItem,
    keyExtractor: function keyExtractor(item) {
      return item.id.toString();
    },
    contentContainerStyle: {
      flexGrow: 1,
      padding: 16
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    style: {
      padding: 16,
      borderTopWidth: 1,
      borderTopColor: _reactNativeUiLib.Colors.dark70
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    style: {
      flexDirection: 'row',
      marginBottom: 8
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Avatar, {
    size: 30,
    label: "U",
    backgroundColor: _reactNativeUiLib.Colors.violet30,
    containerStyle: {
      marginRight: 12
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.TextInput, {
    placeholder: "Write a comment...",
    value: newComment,
    onChangeText: setNewComment,
    style: {
      flex: 1,
      paddingVertical: 8,
      paddingHorizontal: 12,
      borderRadius: 8,
      backgroundColor: _reactNativeUiLib.Colors.dark80,
      color: _reactNativeUiLib.Colors.white
    },
    multiline: true
  })), /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, {
    style: {
      backgroundColor: _reactNativeUiLib.Colors.violet30,
      borderRadius: 8,
      paddingVertical: 12,
      alignItems: 'center'
    },
    onPress: handleCommentSubmit
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Text, {
    style: {
      color: _reactNativeUiLib.Colors.white,
      fontWeight: 'bold'
    }
  }, "Post Comment"))));
};
var TextField = /*#__PURE__*/_react["default"].memo(function (_ref2) {
  var value = _ref2.value,
    _onChange = _ref2.onChange;
  return /*#__PURE__*/_react["default"].createElement(_DynamicForm.CustomTextField, {
    value: value,
    onChange: function onChange(value) {
      _onChange(value);
    }
  });
});
var FormScreen = (0, _mobxReactLite.observer)(function FormScreen(props) {
  var _params, _params2, _window, _params17, _params20, _params21, _params22, _params23, _params24, _params25, _params26, _params27, _params28, _params29, _params30, _params31, _params32, _params33, _params34, _params35, _params36;
  var route = props.route;
  var getOpenForms = (0, _FormStore.GlobalFormStore)(function (state) {
    return state.openForms;
  });
  var setOpenForm = (0, _FormStore.GlobalFormStore)(function (state) {
    return state.setOpenForm;
  });
  var deleteForm = (0, _FormStore.GlobalFormStore)(function (state) {
    return state.deleteForm;
  });
  var setOpenModal = (0, _ModalStore.GlobalModalStore)(function (state) {
    return state.setOpenModal;
  });
  var globalData = (0, _PermissionStore.GlobalMasterStore)(function (state) {
    return state.globalData;
  });
  var setGlobalData = (0, _PermissionStore.GlobalMasterStore)(function (state) {
    return state.setGlobalData;
  });
  var permissions = (0, _PermissionStore.GlobalMasterStore)(function (state) {
    return state.permissions;
  });
  var queryParams = {};
  var params = route !== null && route !== void 0 && route.params ? route === null || route === void 0 ? void 0 : route.params : (0, _reactRouterDom.useParams)();
  var _useContext = (0, _react.useContext)(_CustomModalProvider.CustomModalContext),
    openCustomModal = _useContext.openCustomModal;
  var _App$useApp = _antd.App.useApp(),
    message = _App$useApp.message,
    modal = _App$useApp.modal;
  if (_reactNative.Platform.OS === 'web') {
    var fullUrl = new URL(window.location.href).search;
    var queryStringStart = fullUrl.indexOf('?');
    var queryString = fullUrl.substring(queryStringStart);
    var queries = queryString.substring(1);
    queries.split('&').forEach(function (pair) {
      var _pair$split = pair.split('='),
        _pair$split2 = _slicedToArray(_pair$split, 2),
        key = _pair$split2[0],
        value = _pair$split2[1];
      queryParams[decodeURIComponent(key)] = decodeURIComponent(value);
    });
    if (!params.ignoreQueryParams) {
      params = _objectSpread(_objectSpread({}, params), queryParams);
    }
  }
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    locationForm = _useState2[0],
    setLocationForm = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = _slicedToArray(_useState3, 2),
    moduleObj = _useState4[0],
    setModuleObj = _useState4[1];
  var moduleObjRef = (0, _react.useRef)(moduleObj);
  var _useState5 = (0, _react.useState)({}),
    _useState6 = _slicedToArray(_useState5, 2),
    modulePrefObj = _useState6[0],
    setModulePreObj = _useState6[1];
  var modulePrefObjRef = (0, _react.useRef)(modulePrefObj);
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    saving = _useState8[0],
    setSaving = _useState8[1];
  var moduleName = (_params = params) !== null && _params !== void 0 && _params.moduleName ? (_params2 = params) === null || _params2 === void 0 ? void 0 : _params2.moduleName : 'Items';
  var _useState9 = (0, _react.useState)(Math.floor(1000 + Math.random() * 9000)),
    _useState10 = _slicedToArray(_useState9, 2),
    formUID = _useState10[0],
    setFormUID = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showPreferences = _useState12[0],
    setShowPreferences = _useState12[1];
  var _useState13 = (0, _react.useState)(0),
    _useState14 = _slicedToArray(_useState13, 2),
    syncClickCount = _useState14[0],
    setSyncClickCount = _useState14[1];
  var _useState15 = (0, _react.useState)(0),
    _useState16 = _slicedToArray(_useState15, 2),
    reloadUI = _useState16[0],
    setReloadUI = _useState16[1];
  var _api$getForm = _api.api.getForm(moduleName),
    fields = _api$getForm.fields,
    dataTabs = _api$getForm.dataTabs,
    preferencesFields = _api$getForm.preferencesFields,
    ExtraSaveComponent = _api$getForm.ExtraSaveComponent,
    customActions = _api$getForm.customActions,
    CustomViewHeader = _api$getForm.CustomViewHeader,
    customHeaderHeight = _api$getForm.customHeaderHeight;
  var _useState17 = (0, _react.useState)(_toConsumableArray(dataTabs ? dataTabs : [])),
    _useState18 = _slicedToArray(_useState17, 2),
    tabs = _useState18[0],
    setTabs = _useState18[1];
  var _useState19 = (0, _react.useState)({
      label: 'Details'
    }),
    _useState20 = _slicedToArray(_useState19, 2),
    activeTab = _useState20[0],
    setActiveTab = _useState20[1];
  var nativeRoute = (0, _native.useNavigationState)(function (state) {
    return state;
  });
  var navigation = (0, _native.useNavigation)();
  var navigate = null;
  if (_reactNative.Platform.OS === 'web') {
    navigate = (0, _reactRouterDom.useNavigate)();
  }
  var navigationFn = function navigationFn(path) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (_reactNative.Platform.OS === 'web') {
      var paramsString = "";
      if (params) {
        paramsString = "?" + Object.keys(params).map(function (key) {
          return key + '=' + params[key];
        }).join('&');
      }
      navigate("/" + "redirect");
      setTimeout(function () {
        navigate("/" + path + paramsString);
      }, 0);
    } else {
      if (path.includes("report/")) {
        navigation.push("report", _objectSpread(_objectSpread({}, params), {}, {
          name: path.replace("report/", "")
        }));
      } else {
        navigation.push(path, params);
      }
    }
  };
  var goBack = function goBack() {
    if (_reactNative.Platform.OS === 'web') {
      setOpenModal(_defineProperty({}, moduleName, null));
    } else {
      navigation.pop();
    }
  };
  var getOpenFormsRef = (0, _react.useRef)(getOpenForms);
  (0, _react.useEffect)(function () {
    getOpenFormsRef.current = getOpenForms;
  }, [getOpenForms]);
  var OpenModalCustom = function OpenModalCustom(_ref3) {
    var newModule = _ref3.newModule,
      field_key = _ref3.field_key,
      _ref3$array = _ref3.array,
      array = _ref3$array === void 0 ? false : _ref3$array,
      _ref3$params = _ref3.params,
      params = _ref3$params === void 0 ? null : _ref3$params;
    _reactNative.DeviceEventEmitter.addListener("reloadData" + formUID, function (event) {
      if (!event) {
        _reactNative.DeviceEventEmitter.removeAllListeners("reloadData" + formUID);
        // if (Platform.OS == 'web') {
        //   setOpenModal({ [moduleName]: null })
        // } else {
        //   
        //   navigation.pop();
        // }
        return;
      }
      if (event !== null && event !== void 0 && event.deleted) {
        _reactNative.DeviceEventEmitter.removeAllListeners("reloadData" + formUID);
        var _object = _objectSpread({}, moduleObjRef.current);
        if (event !== null && event !== void 0 && event.id && field_key) {
          if (array) {
            var oldValues = _object[field_key] ? _object[field_key] : [];
            _object[field_key] = oldValues.filter(function (id) {
              return id != (event === null || event === void 0 ? void 0 : event.id);
            });
          } else {
            _object[field_key] = null;
          }
        }
        getModuleCreateData(_object);
        if (_reactNative.Platform.OS == 'web') {
          setOpenModal(_defineProperty({}, newModule, null));
        } else {
          goBack();
        }
        return;
      }
      var object = _objectSpread({}, moduleObjRef.current);
      if (field_key) {
        if (array) {
          var _oldValues = object[field_key] ? object[field_key] : [];
          object[field_key] = _toConsumableArray(new Set([].concat(_toConsumableArray(_oldValues), [event._id])));
        } else {
          object[field_key] = event._id;
        }
      }
      getModuleCreateData(object);

      // if (Platform.OS == 'web') {
      //   setOpenModal({
      //     [newModule]: null
      //   })
      // } else {
      //   goBack();
      // }

      _reactNative.DeviceEventEmitter.removeAllListeners("reloadData" + formUID);
    });
    if (_reactNative.Platform.OS == 'web') {
      var data = _defineProperty({}, newModule, _objectSpread({
        isVisible: true,
        moduleName: [newModule],
        viewOnly: false,
        afterSaveEvent: 'reloadData' + formUID,
        ignoreQueryParams: true
      }, params ? params : {}));
      setOpenModal(data);
    } else {
      navigationFn('New', _objectSpread({
        moduleName: newModule,
        afterSaveEvent: 'reloadData' + formUID
      }, params ? params : {}));
    }
  };
  var getModuleCreateData = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _params3, _params4, _params5;
      var values,
        isEdit,
        response,
        _params6,
        _params7,
        _params8,
        _params9,
        _params10,
        _params11,
        id,
        cloningModuleName,
        _yield$api$getSingle,
        data,
        form,
        _params12,
        object,
        finalObj,
        _params13,
        _form,
        _params14,
        _data2,
        _params15,
        _params16,
        newObject,
        _args = arguments;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            values = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
            isEdit = ((_params3 = params) === null || _params3 === void 0 ? void 0 : _params3.isEdit) == "true" || ((_params4 = params) === null || _params4 === void 0 ? void 0 : _params4.isEdit) == true;
            _context.next = 4;
            return _api.api.getCreateData(moduleName, params);
          case 4:
            response = _context.sent;
            if (!((_params5 = params) !== null && _params5 !== void 0 && _params5.id)) {
              _context.next = 21;
              break;
            }
            id = (_params6 = params) === null || _params6 === void 0 ? void 0 : _params6.id;
            cloningModuleName = (_params7 = params) !== null && _params7 !== void 0 && _params7.cloningModuleName ? (_params8 = params) === null || _params8 === void 0 ? void 0 : _params8.cloningModuleName : moduleName;
            _context.next = 10;
            return _api.api.getSingle(cloningModuleName, {
              _id: id,
              converting: cloningModuleName == moduleName ? false : true,
              isClone: (_params9 = params) !== null && _params9 !== void 0 && _params9.isClone ? true : false,
              isEdit: (_params10 = params) !== null && _params10 !== void 0 && _params10.isEdit ? true : false,
              platform: _reactNative.Platform.OS
            });
          case 10:
            _yield$api$getSingle = _context.sent;
            data = _yield$api$getSingle.data;
            form = _api.api.objectToForm(data, fields(response, (_params11 = params) === null || _params11 === void 0 ? void 0 : _params11.viewOnly, moduleName, OpenModalCustom, data, isEdit, globalData, setGlobalData, message, navigationFn, permissions));
            if (values) {
              form = _api.api.objectToForm(values, fields(response, (_params12 = params) === null || _params12 === void 0 ? void 0 : _params12.viewOnly, moduleName, OpenModalCustom, data, isEdit, globalData, setGlobalData, message, navigationFn, permissions));
            }
            object = _api.api.formToObject(form);
            finalObj = _objectSpread(_objectSpread({}, data), object);
            setOpenForm(_defineProperty(_defineProperty({}, formUID + "Object", finalObj), formUID + "Form", form));
            moduleObjRef.current = finalObj;
            setModuleObj(finalObj);
            _context.next = 28;
            break;
          case 21:
            _form = null;
            if ((_params13 = params) !== null && _params13 !== void 0 && _params13.is_default_values) {
              _data2 = _objectSpread({}, params);
              delete _data2.is_default_values;
              delete _data2.moduleName;
              _form = _api.api.objectToForm(_data2, fields(response, (_params14 = params) === null || _params14 === void 0 ? void 0 : _params14.viewOnly, moduleName, OpenModalCustom, _data2, false, globalData, setGlobalData, message, navigationFn, permissions));
            } else {
              _form = fields(response, (_params15 = params) === null || _params15 === void 0 ? void 0 : _params15.viewOnly, moduleName, OpenModalCustom, values, false, globalData, setGlobalData, message, navigationFn);
            }
            if (values) {
              _form = _api.api.objectToForm(values, fields(response, (_params16 = params) === null || _params16 === void 0 ? void 0 : _params16.viewOnly, moduleName, OpenModalCustom, values, false, globalData, setGlobalData, message, navigationFn, permissions));
            }
            setOpenForm(_defineProperty(_defineProperty({}, formUID + "Object", {}), formUID + "Form", _form));
            newObject = _api.api.formToObject(_form);
            moduleObjRef.current = newObject;
            setModuleObj(newObject);
          case 28:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getModuleCreateData() {
      return _ref4.apply(this, arguments);
    };
  }();
  function saveFn(_x) {
    return _saveFn.apply(this, arguments);
  }
  function _saveFn() {
    _saveFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(mainObject) {
      var stay_on_page,
        ignore_message,
        form,
        object,
        res,
        _args7 = arguments;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            stay_on_page = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : false;
            ignore_message = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : false;
            _context7.prev = 2;
            setSaving(true);
            form = _api.api.objectToForm(mainObject, getOpenForms[formUID + "Form"]);
            object = _objectSpread(_objectSpread({}, mainObject), _api.api.formToObject(form));
            res = null;
            object.location_id = globalData.location_id;
            if (!(params.isEdit == "true" || params.isEdit == true)) {
              _context7.next = 14;
              break;
            }
            _context7.next = 11;
            return _api.api.update(moduleName, object, params.id);
          case 11:
            res = _context7.sent;
            _context7.next = 17;
            break;
          case 14:
            _context7.next = 16;
            return _api.api.save(moduleName, object);
          case 16:
            res = _context7.sent;
          case 17:
            if (!res.message) {
              _context7.next = 26;
              break;
            }
            if (!ignore_message) {
              if (_reactNative.Platform.OS === 'web') {
                message.success(res.message);
              } else {
                _reactNative.Alert.alert(res.message);
              }
            }
            setSaving(false);
            if (!res.success) {
              _context7.next = 24;
              break;
            }
            if (params.afterSaveEvent) {
              _reactNative.DeviceEventEmitter.emit(params.afterSaveEvent, {
                _id: res.data._id
              });
            }
            if (!stay_on_page) {
              if (_reactNative.Platform.OS == 'web') {
                setOpenModal(_defineProperty({}, moduleName, null));
                deleteForm(formUID + "Form");
                deleteForm(formUID + "Object");
              } else {
                if (!params.afterSaveEvent) {
                  _reactNative.DeviceEventEmitter.emit("reloadListing", {
                    _id: res.data._id
                  });
                  navigation.pop();
                } else {
                  navigation.pop();
                }
              }
            } else {
              //reload 
              params.id = res.data._id;
              params.isEdit = true;
              getModuleCreateData(null, {
                id: res.data._id,
                isEdit: true
              });
              setReloadUI(Math.random());
            }
            return _context7.abrupt("return", res.data._id);
          case 24:
            _context7.next = 29;
            break;
          case 26:
            console.log(res);
            if (_reactNative.Platform.OS === 'web') {
              message.error("Something went wrong!");
            } else {
              _reactNative.Alert.alert("Something went wrong!");
            }
            setSaving(false);
          case 29:
            _context7.next = 36;
            break;
          case 31:
            _context7.prev = 31;
            _context7.t0 = _context7["catch"](2);
            console.log("error", _context7.t0);
            if (_reactNative.Platform.OS === 'web') {
              message.error("Something went wrong!");
            } else {
              _reactNative.Alert.alert("Something went wrong!");
            }
            setSaving(false);
          case 36:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[2, 31]]);
    }));
    return _saveFn.apply(this, arguments);
  }
  function deleteFn(_x2) {
    return _deleteFn.apply(this, arguments);
  }
  function _deleteFn() {
    _deleteFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(mainObject) {
      var actualDeleteFn, _actualDeleteFn;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            _actualDeleteFn = function _actualDeleteFn3() {
              _actualDeleteFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
                var res;
                return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                  while (1) switch (_context10.prev = _context10.next) {
                    case 0:
                      _context10.prev = 0;
                      _context10.next = 3;
                      return _api.api["delete"](moduleName, mainObject._id);
                    case 3:
                      res = _context10.sent;
                      if (res.message) {
                        if (_reactNative.Platform.OS === 'web') {
                          message.success(res.message);
                        } else {
                          _reactNative.Alert.alert(res.message);
                        }
                        if (res.success) {
                          if (params.afterSaveEvent) {
                            _reactNative.DeviceEventEmitter.emit(params.afterSaveEvent, {
                              deleted: true,
                              id: mainObject._id
                            });
                          }
                          setOpenModal(_defineProperty({}, moduleName, null));
                          deleteForm(formUID + "Form");
                          deleteForm(formUID + "Object");
                          if (_reactNative.Platform.OS != 'web') {
                            navigation.pop();
                          }
                        }
                      } else {
                        if (_reactNative.Platform.OS === 'web') {
                          message.error("Something went wrong!");
                        } else {
                          _reactNative.Alert.alert("Something went wrong!");
                        }
                      }
                      _context10.next = 10;
                      break;
                    case 7:
                      _context10.prev = 7;
                      _context10.t0 = _context10["catch"](0);
                      if (_reactNative.Platform.OS === 'web') {
                        message.error("Something went wrong!");
                      } else {
                        _reactNative.Alert.alert("Something went wrong!");
                      }
                    case 10:
                    case "end":
                      return _context10.stop();
                  }
                }, _callee10, null, [[0, 7]]);
              }));
              return _actualDeleteFn.apply(this, arguments);
            };
            actualDeleteFn = function _actualDeleteFn2() {
              return _actualDeleteFn.apply(this, arguments);
            };
            if (_reactNative.Platform.OS === 'web') {
              modal.confirm({
                title: 'Are you sure you want to delete?',
                content: 'This action cannot be undone.',
                okText: 'Yes',
                cancelText: 'No',
                onOk: function () {
                  var _onOk2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
                    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                      while (1) switch (_context8.prev = _context8.next) {
                        case 0:
                          _context8.next = 2;
                          return actualDeleteFn();
                        case 2:
                        case "end":
                          return _context8.stop();
                      }
                    }, _callee8);
                  }));
                  function onOk() {
                    return _onOk2.apply(this, arguments);
                  }
                  return onOk;
                }(),
                onCancel: function onCancel() {}
              });
            } else {
              _reactNative.Alert.alert("Are you sure you want to delete?", "This action cannot be undone.", [{
                text: "Yes",
                onPress: function () {
                  var _onPress2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
                    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                      while (1) switch (_context9.prev = _context9.next) {
                        case 0:
                          _context9.next = 2;
                          return actualDeleteFn();
                        case 2:
                        case "end":
                          return _context9.stop();
                      }
                    }, _callee9);
                  }));
                  function onPress() {
                    return _onPress2.apply(this, arguments);
                  }
                  return onPress;
                }(),
                style: "default"
              }, {
                text: "No",
                onPress: function onPress() {},
                style: "cancel"
              }]);
            }
          case 3:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    return _deleteFn.apply(this, arguments);
  }
  function syncData() {
    return _syncData.apply(this, arguments);
  }
  function _syncData() {
    _syncData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
      var res;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            console.log(syncClickCount);
            if (!(syncClickCount < 5)) {
              _context12.next = 4;
              break;
            }
            setSyncClickCount(syncClickCount + 1);
            return _context12.abrupt("return");
          case 4:
            _context12.prev = 4;
            console.log("syncing", moduleName, moduleObjRef.current._id);
            _context12.next = 8;
            return _api.api.sync(moduleName, moduleObjRef.current._id);
          case 8:
            res = _context12.sent;
            if (res.message) {
              if (_reactNative.Platform.OS === 'web') {
                message.success(res.message);
              } else {
                _reactNative.Alert.alert(res.message);
              }
            }
            _context12.next = 16;
            break;
          case 12:
            _context12.prev = 12;
            _context12.t0 = _context12["catch"](4);
            console.log(_context12.t0);
            console.log("syncing", moduleName, moduleObjRef.current._id);
          case 16:
            _context12.prev = 16;
            setSyncClickCount(0);
            return _context12.finish(16);
          case 19:
          case "end":
            return _context12.stop();
        }
      }, _callee12, null, [[4, 12, 16, 19]]);
    }));
    return _syncData.apply(this, arguments);
  }
  function cancelFn() {
    return _cancelFn.apply(this, arguments);
  }
  function _cancelFn() {
    _cancelFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
      return _regeneratorRuntime().wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            if (params.afterSaveEvent) {
              _reactNative.DeviceEventEmitter.emit(params.afterSaveEvent, {
                deleted: false
              });
            }
            if (_reactNative.Platform.OS == 'web') {
              setOpenModal(_defineProperty({}, moduleName, null));
            } else {
              navigation.pop();
            }
            deleteForm(formUID + "Form");
            deleteForm(formUID + "Object");
          case 4:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    }));
    return _cancelFn.apply(this, arguments);
  }
  function reloadModuleData() {
    var object = _objectSpread({}, moduleObjRef.current);
    getModuleCreateData(object);
  }
  (0, _react.useEffect)(function () {
    getModuleCreateData();
    return function () {
      _reactNative.DeviceEventEmitter.emit(params.afterSaveEvent, null);
      deleteForm(formUID + "Form");
      deleteForm(formUID + "Object");
      deleteForm(formUID + "Form" + "Preferences");
      deleteForm(formUID + "Object" + "Preferences");
    };
  }, [(_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.href, (_params17 = params) === null || _params17 === void 0 ? void 0 : _params17.viewOnly]);
  (0, _react.useEffect)(function () {
    if (_reactNative.Platform.OS == 'web') {
      var Mousetrap = require('mousetrap');
      Mousetrap.bind('esc', function () {
        cancelFn();
      });
      Mousetrap.prototype.stopCallback = function (e) {
        var selectDropdowns = document.querySelectorAll('.ant-select-dropdown');
        var pickerDropdowns = document.querySelectorAll('.ant-picker-dropdown');
        var isAnyOpen = false;
        selectDropdowns.forEach(function (dropdown) {
          if (!dropdown.classList.contains('ant-select-dropdown-hidden')) {
            isAnyOpen = true;
          }
        });
        pickerDropdowns.forEach(function (dropdown) {
          if (!dropdown.classList.contains('ant-picker-dropdown-hidden')) {
            isAnyOpen = true;
          }
        });
        return isAnyOpen;
      };
    }
    return function () {
      if (_reactNative.Platform.OS == 'web') {
        var _Mousetrap = require('mousetrap');
        _Mousetrap.unbind('esc');
      }
    };
  }, []);
  var changeTab = function changeTab(index) {
    var tab = tabs[index];
    setActiveTab(tab);
  };
  var actionFunctions = function actionFunctions(row) {
    var actions = [{
      label: 'Edit',
      key: 'update',
      fn: function fn(_ref5) {
        var data = _ref5.data,
          updateData = _ref5.updateData,
          row = _ref5.row,
          row_index = _ref5.row_index;
        if (_reactNative.Platform.OS === 'web') {
          setOpenModal(_defineProperty({}, moduleName, _objectSpread(_objectSpread({}, params ? params : {}), {}, {
            isVisible: true,
            moduleName: moduleName,
            id: row._id,
            viewOnly: false,
            isEdit: true,
            afterSaveEvent: params.afterSaveEvent ? params.afterSaveEvent : 'reloadListing'
          })));
        } else {
          navigationFn('New', _objectSpread(_objectSpread({}, params ? params : {}), {}, {
            moduleName: moduleName,
            isEdit: true,
            viewOnly: false,
            id: row._id,
            goBackAfterSave: true
          }));
        }
      }
    }, {
      label: 'Clone',
      key: 'create',
      fn: function fn(_ref6) {
        var data = _ref6.data,
          updateData = _ref6.updateData,
          row = _ref6.row,
          row_index = _ref6.row_index;
        if (_reactNative.Platform.OS === 'web') {
          setOpenModal(_defineProperty({}, moduleName, {
            isVisible: true,
            moduleName: moduleName,
            id: row._id,
            afterSaveEvent: 'reloadListing'
          }));
        } else {
          navigationFn('New', {
            moduleName: moduleName,
            id: row._id,
            goBackAfterSave: true
          });
        }
      }
    }].concat(_toConsumableArray(customActions ? customActions(moduleName, navigationFn, route, row, setOpenModal, openCustomModal) : []), [{
      label: 'Delete',
      key: 'delete',
      fn: function fn(_ref7) {
        var data = _ref7.data,
          updateData = _ref7.updateData,
          row = _ref7.row,
          row_index = _ref7.row_index;
        var deleteFn = /*#__PURE__*/function () {
          var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
            var res;
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  _context2.next = 3;
                  return _api.api["delete"](moduleName, row._id);
                case 3:
                  res = _context2.sent;
                  if (res.message) {
                    if (_reactNative.Platform.OS === 'web') {
                      message.success(res.message);
                    } else {
                      _reactNative.Alert.alert(res.message);
                    }
                    if (res.success) {
                      getModuleData();
                    }
                  } else {
                    if (_reactNative.Platform.OS === 'web') {
                      message.error("Something went wrong!");
                    } else {
                      _reactNative.Alert.alert("Something went wrong!");
                    }
                  }
                  _context2.next = 10;
                  break;
                case 7:
                  _context2.prev = 7;
                  _context2.t0 = _context2["catch"](0);
                  if (_reactNative.Platform.OS === 'web') {
                    message.error("Something went wrong!");
                  } else {
                    _reactNative.Alert.alert("Something went wrong!");
                  }
                case 10:
                case "end":
                  return _context2.stop();
              }
            }, _callee2, null, [[0, 7]]);
          }));
          return function deleteFn() {
            return _ref8.apply(this, arguments);
          };
        }();
        if (_reactNative.Platform.OS === 'web') {
          modal.confirm({
            title: 'Are you sure you want to delete?',
            content: 'This action cannot be undone.',
            okText: 'Yes',
            cancelText: 'No',
            onOk: function () {
              var _onOk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return deleteFn();
                    case 2:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }));
              function onOk() {
                return _onOk.apply(this, arguments);
              }
              return onOk;
            }(),
            onCancel: function onCancel() {}
          });
        } else {
          _reactNative.Alert.alert("Are you sure you want to delete?", "This action cannot be undone.", [{
            text: "Yes",
            onPress: function () {
              var _onPress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return deleteFn();
                    case 2:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }));
              function onPress() {
                return _onPress.apply(this, arguments);
              }
              return onPress;
            }(),
            style: "default"
          }, {
            text: "No",
            onPress: function onPress() {},
            style: "cancel"
          }]);
        }
      }
    }]);
    var newActions = actions.filter(function (action) {
      if (permissions[moduleName] && permissions[moduleName][action.key]) {
        return true;
      } else {
        return true;
      }
    });
    newActions = newActions.filter(function (action) {
      var _params18, _params19;
      if (row.disable_editing || (_params18 = params) !== null && _params18 !== void 0 && _params18.disableEdit) {
        if (action.key === 'update') {
          return false;
        } else {
          return true;
        }
      }
      if (row.disable_deleting || (_params19 = params) !== null && _params19 !== void 0 && _params19.disableDelete) {
        if (action.key === 'delete') {
          return false;
        } else {
          return true;
        }
      }
      return true;
    });
    return newActions;
  };
  var readableModuleName = _pluralize["default"].singular(((_params20 = params) === null || _params20 === void 0 || (_params20 = _params20.moduleName) === null || _params20 === void 0 ? void 0 : _params20.replace(/([A-Z])/g, ' $1').trim()) || '');
  var HeaderExtra = /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    row: true,
    centerV: true
  }, ((_params21 = params) === null || _params21 === void 0 ? void 0 : _params21.viewOnly) != true && /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    row: true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    flex: true,
    left: true,
    "marginR-10": true,
    "marginT-10": true,
    style: {
      zIndex: 2
    },
    "w-100": true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    flex: true,
    "w-100": true,
    row: true
  }, preferencesFields && _reactNative.Platform.OS == 'web' ? /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, {
    onPress: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var response, data, form, object;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _api.api.getCreateData(moduleName);
          case 2:
            response = _context5.sent;
            _context5.next = 5;
            return _api.api.getPreferenceData(moduleName);
          case 5:
            data = _context5.sent;
            form = _api.api.objectToForm(data, preferencesFields(response, false, moduleName, OpenModalCustom, data, false, globalData, setGlobalData, message, navigationFn, permissions));
            object = _api.api.formToObject(form);
            setModulePreObj(object);
            setOpenForm(_defineProperty(_defineProperty({}, formUID + "Preferences" + "Object", object), formUID + "Preferences" + "Form", form));
            setShowPreferences(!showPreferences);
          case 11:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    row: true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeEvaIcons.Icon, {
    name: "settings-2-outline",
    width: 12,
    height: 12,
    fill: '#979899'
  }), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Text, {
    style: {
      color: '#979899',
      fontFamily: 'SourceSansProSemiBold',
      fontSize: 12,
      letterSpacing: 0.3,
      lineHeight: 13,
      textTransform: 'uppercase',
      marginLeft: 5
    }
  }, "Preferences"))) : null))), permissions[moduleName] && permissions[moduleName]['update'] && ((_params22 = params) === null || _params22 === void 0 ? void 0 : _params22.viewOnly) == true && !((_params23 = params) !== null && _params23 !== void 0 && _params23.hideEditButton) && actionFunctions(moduleObj).findIndex(function (el) {
    return el.key == 'update';
  }) >= 0 && /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    row: true
  }, /*#__PURE__*/_react["default"].createElement(_DynamicForm.SecondaryButton, {
    style: {
      marginRight: 5,
      backgroundColor: "white"
    },
    label: "Edit",
    onPress: function onPress() {
      actionFunctions(moduleObj)[actionFunctions(moduleObj).findIndex(function (el) {
        return el.key == 'update';
      })].fn({
        data: moduleObj,
        updateData: setModuleObj,
        row: moduleObj,
        row_index: 0
      });
    }
  }), _reactNative.Platform.OS == 'web' && ((_params24 = params) === null || _params24 === void 0 ? void 0 : _params24.viewOnly) == true && !((_params25 = params) !== null && _params25 !== void 0 && _params25.hideEditButton) && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end'
    }
  }, actionFunctions ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "actions-container"
  }, actionFunctions && actionFunctions(moduleObj).length >= 1 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, actionFunctions && actionFunctions(moduleObj).length == 1 && actionFunctions(moduleObj)[0].label == "Delete" ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      cursor: 'pointer',
      height: 40,
      width: 40,
      display: 'flex',
      justifyItems: 'center',
      alignItems: 'center'
    },
    onClick: function onClick() {
      actionFunctions(moduleObj)[0].fn({
        data: moduleObj,
        updateData: moduleObj,
        row: moduleObj,
        row_index: 0
      });
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: "https://cdn-icons-png.flaticon.com/512/11847/11847093.png",
    style: {
      width: 20,
      height: 20
    }
  }))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "dropdown"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "pointer",
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/_react["default"].createElement(_antd.Dropdown, {
    menu: {
      items: actionFunctions(moduleObj).filter(function (action) {
        return action.label != "Edit";
      }).map(function (action) {
        return {
          label: action.label,
          onClick: function onClick() {
            return action.fn({
              data: moduleObj,
              updateData: moduleObj,
              row: moduleObj,
              row_index: 0
            });
          }
        };
      })
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    left: true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Button, {
    avoidMinWidth: true,
    borderRadius: 4,
    outline: true,
    outlineColor: "#edf2f9",
    style: {
      boxShadow: '0 2px 0 rgba(0,0,0, 0.015)',
      backgroundColor: 'white',
      height: 40
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeEvaIcons.Icon, {
    name: "more-vertical-outline",
    width: 16,
    height: 16,
    fill: "#53535f"
  }))))))) : null) : null)), _reactNative.Platform.OS == 'web' && /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, {
    style: CustomViewHeader ? {
      backgroundColor: 'white',
      padding: 7,
      borderRadius: 5
    } : {
      marginRight: 5
    },
    onPress: function onPress() {
      goBack();
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeEvaIcons.Icon, {
    name: "close-outline",
    width: 20,
    height: 20,
    fill: '#5670a1'
  })));
  return /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    useSafeArea: true,
    key: reloadUI
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Card, {
    style: _reactNative.Platform.OS == 'web' ? {
      overflow: 'hidden',
      height: _reactNative.Dimensions.get('window').height,
      borderRadius: 0
    } : {}
  }, props.hideHeader ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null) : CustomViewHeader && (((_params26 = params) === null || _params26 === void 0 ? void 0 : _params26.viewOnly) == "true" || ((_params27 = params) === null || _params27 === void 0 ? void 0 : _params27.viewOnly) == true) ? /*#__PURE__*/_react["default"].createElement(CustomViewHeader, {
    HeaderExtra: HeaderExtra,
    connectedObject: moduleObj
  }) : /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    "padding-15": true,
    "paddingB-10": true,
    style: {
      backgroundColor: '#0a152f',
      borderRadius: 10,
      borderBottomEndRadius: 0,
      borderBottomStartRadius: 0
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    spread: true,
    row: true,
    centerV: true
  }, _reactNative.Platform.OS != 'web' && (!((_params28 = params) !== null && _params28 !== void 0 && _params28.viewOnly) ? /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Text, {
    color: "white",
    h1: true
  }, ((_params29 = params) === null || _params29 === void 0 ? void 0 : _params29.isEdit) == true || ((_params30 = params) === null || _params30 === void 0 ? void 0 : _params30.isEdit) == "true" ? "Edit " + readableModuleName : "New " + readableModuleName) : /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Text, {
    h1: true
  }, readableModuleName)), _reactNative.Platform.OS == 'web' && /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    row: true,
    centerV: true
  }, _reactNative.Platform.OS == 'web' && /*#__PURE__*/_react["default"].createElement(_DynamicForm.DangerButton, {
    style: {
      height: 32,
      marginRight: 12
    },
    onPress: function onPress() {
      goBack();
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    row: true,
    centerV: true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeEvaIcons.Icon, {
    name: "arrow-back-outline",
    width: 16,
    height: 16,
    fill: "#b60505"
  }), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Text, {
    "marginL-5": true,
    style: {
      color: '#b60505',
      fontFamily: 'SourceSansProSemiBold'
    }
  }, "Go Back"))), "(", !((_params31 = params) !== null && _params31 !== void 0 && _params31.viewOnly) ? /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Text, {
    color: "white",
    h1: true
  }, ((_params32 = params) === null || _params32 === void 0 ? void 0 : _params32.isEdit) == true || ((_params33 = params) === null || _params33 === void 0 ? void 0 : _params33.isEdit) == "true" ? "Edit " + readableModuleName : "New " + readableModuleName) : /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Text, {
    color: "white",
    h1: true
  }, readableModuleName), ")"), HeaderExtra)), preferencesFields ? /*#__PURE__*/_react["default"].createElement(_DynamicForm.CustomModal, {
    drawer: true,
    width: "70%",
    visible: showPreferences,
    onClose: function onClose() {
      setShowPreferences(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_DynamicForm["default"], {
    formUID: formUID + "Preferences",
    connectedObject: modulePrefObj,
    connectedObjectRef: modulePrefObjRef,
    setConnectedObject: setModulePreObj,
    getOpenForms: getOpenForms,
    setOpenForm: setOpenForm,
    preferences: true,
    saveFn: ( /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(mainObject) {
        var form, object, res, _window2;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              setSaving(true);
              form = _api.api.objectToForm(mainObject, getOpenForms[formUID + "Preferences" + "Form"]);
              object = _objectSpread(_objectSpread({}, mainObject), _api.api.formToObject(form));
              _context6.next = 5;
              return _api.api.savePreferenceData(moduleName, object);
            case 5:
              res = _context6.sent;
              ;
              if (res.message) {
                if (_reactNative.Platform.OS === 'web') {
                  message.success(res.message);
                } else {
                  _reactNative.Alert.alert(res.message);
                }
                setSaving(false);
                if (res.success) {
                  setShowPreferences(false);
                  reloadModuleData();
                }
              } else {
                _reactNative.Alert.alert("Something went wrong!");
                if ((_window2 = window) !== null && _window2 !== void 0 && _window2.alert) {
                  window.alert("Something went wrong!");
                }
                setSaving(false);
              }
            case 8:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function (_x3) {
        return _ref10.apply(this, arguments);
      };
    }())
  })) : null, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, null, activeTab.label.includes("Details") && /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, null, /*#__PURE__*/_react["default"].createElement(_DynamicForm["default"], {
    viewOnly: (_params34 = params) !== null && _params34 !== void 0 && _params34.viewOnly ? (_params35 = params) === null || _params35 === void 0 ? void 0 : _params35.viewOnly : false,
    formUID: formUID,
    connectedObject: moduleObj,
    moduleName: moduleName,
    connectedObjectRef: moduleObjRef,
    setConnectedObject: setModuleObj,
    getOpenForms: getOpenForms,
    setOpenForm: setOpenForm,
    dataTabs: dataTabs,
    saveFn: saveFn,
    cancelFn: cancelFn,
    deleteFn: (_params36 = params) !== null && _params36 !== void 0 && _params36.isEdit ? deleteFn : null,
    ExtraSaveComponent: ExtraSaveComponent,
    customHeaderHeight: customHeaderHeight,
    hideHeader: props.hideHeader
  })), activeTab.label.includes("Comments") && /*#__PURE__*/_react["default"].createElement(CommentsSection, null), activeTab.label.includes("Documents") && /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, null, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Text, null, "Documents")), !["Details", "Comments", "Documents"].includes(activeTab.label) && /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, null, /*#__PURE__*/_react["default"].createElement(activeTab.component, {
    moduleName: moduleName,
    obj: moduleObj
  })))));
});
var _default = exports["default"] = FormScreen;
var $container = {
  flex: 1
};